import React from 'react';
import { HelpCircle, ThumbsUp, AlertCircle, Lightbulb } from 'lucide-react';
import { useTheme } from '../../../contexts/ThemeContext';

const TabelaCategorias = ({ metricas, loading }) => {
  const { darkMode } = useTheme();

  if (loading) {
    return (
      <div
        className={`p-6 rounded-lg animate-pulse ${
          darkMode ? 'bg-zinc-800' : 'bg-white'
        }`}
      >
        <div className={`h-4 ${darkMode ? 'bg-zinc-700' : 'bg-gray-200'} rounded w-1/4 mb-4`}></div>
        <div className="space-y-3">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className={`h-12 ${darkMode ? 'bg-zinc-700' : 'bg-gray-200'} rounded`}></div>
          ))}
        </div>
      </div>
    );
  }

  if (!metricas || metricas.length === 0) {
    return null;
  }

  // Agregar dados de categorias
  const totalDuvidas = metricas.reduce((sum, m) => sum + (m.total_duvidas || 0), 0);
  const totalElogios = metricas.reduce((sum, m) => sum + (m.total_elogios || 0), 0);
  const totalReclamacoes = metricas.reduce((sum, m) => sum + (m.total_reclamacoes || 0), 0);
  const totalSugestoes = metricas.reduce((sum, m) => sum + (m.total_sugestoes || 0), 0);
  const total = totalDuvidas + totalElogios + totalReclamacoes + totalSugestoes;

  if (total === 0) {
    return null;
  }

  const categorias = [
    {
      nome: 'Dúvidas',
      total: totalDuvidas,
      percent: ((totalDuvidas / total) * 100).toFixed(1),
      icon: HelpCircle,
      color: 'blue',
      bgColor: darkMode ? 'bg-blue-900/20' : 'bg-blue-50',
      textColor: 'text-blue-500',
    },
    {
      nome: 'Elogios',
      total: totalElogios,
      percent: ((totalElogios / total) * 100).toFixed(1),
      icon: ThumbsUp,
      color: 'green',
      bgColor: darkMode ? 'bg-green-900/20' : 'bg-green-50',
      textColor: 'text-green-500',
    },
    {
      nome: 'Reclamações',
      total: totalReclamacoes,
      percent: ((totalReclamacoes / total) * 100).toFixed(1),
      icon: AlertCircle,
      color: 'red',
      bgColor: darkMode ? 'bg-red-900/20' : 'bg-red-50',
      textColor: 'text-red-500',
    },
    {
      nome: 'Sugestões',
      total: totalSugestoes,
      percent: ((totalSugestoes / total) * 100).toFixed(1),
      icon: Lightbulb,
      color: 'yellow',
      bgColor: darkMode ? 'bg-yellow-900/20' : 'bg-yellow-50',
      textColor: 'text-yellow-500',
    },
  ].filter(cat => cat.total > 0);

  return (
    <div
      className={`p-6 rounded-lg border ${
        darkMode ? 'bg-zinc-800 border-gray-700' : 'bg-white border-gray-200'
      }`}
    >
      <h3
        className={`text-lg font-semibold mb-4 ${
          darkMode ? 'text-white' : 'text-gray-900'
        }`}
      >
        Categorias de Interação
      </h3>

      <div className="space-y-3">
        {categorias.map((categoria, index) => {
          const Icon = categoria.icon;
          return (
            <div
              key={index}
              className={`p-3 sm:p-4 rounded-lg ${categoria.bgColor}`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <Icon className={`w-5 h-5 ${categoria.textColor}`} />
                  <span
                    className={`font-medium ${
                      darkMode ? 'text-white' : 'text-gray-900'
                    }`}
                  >
                    {categoria.nome}
                  </span>
                </div>
                <div className="flex items-center space-x-2 sm:space-x-4">
                  <span className={`text-xl sm:text-2xl font-bold ${categoria.textColor}`}>
                    {categoria.total}
                  </span>
                  <span className={`text-sm ${categoria.textColor}`}>
                    {categoria.percent}%
                  </span>
                </div>
              </div>
              {/* Barra de progresso */}
              <div className="mt-2 w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${categoria.textColor.replace('text-', 'bg-')}`}
                  style={{ width: `${categoria.percent}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TabelaCategorias;
